import { useContext } from "react";
import { CarouselContext, CarouselContextType } from "../providers";

export function useCarousel(): CarouselContextType {
  return useContext(CarouselContext);
}
